import { combineReducers } from '@reduxjs/toolkit';
import menuListReducer from './list/listSlice';
import updateMenuSlice from './update/updateSlice';

const menuSlice = combineReducers({
    list: menuListReducer,
    update: updateMenuSlice,
});

export default menuSlice;
